import { IRIS_S1_PROMOTIONALBANNERDATA_GET_SUCCESS } from '../actionTypes/PromotionalBannerActionTypes';

function IrisS1PromotionalBannerReducer(state = {}, action) {
    switch (action.type) {
        case IRIS_S1_PROMOTIONALBANNERDATA_GET_SUCCESS:
            return {
                ...state,
                ...action.bannerInfo,
            };
        default:
            return state;
    }
}

IrisS1PromotionalBannerReducer.reducerName = 'irisS1PromotionalBannerReducerData';
export default IrisS1PromotionalBannerReducer;
